import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-courier-note',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './courier-note.component.html',
  styleUrls: ['./courier-note.component.scss'],
})
export class CourierNoteComponent {
  @Input() color!: string;
}
